import { useContext } from "react";
import { RootAppStoreContext } from "@state/context/root-store/RootAppStoreContext";
import { MobilePlatform, WebPlatform } from "@state/stores/types";
import DesktopRootStore from "@state/stores/RootStore";
import MobileRootStore from "@state/stores/RootStore.mobile";

export function useRootAppStore<
	T extends WebPlatform | MobilePlatform = WebPlatform,
>() {
	return useContext(RootAppStoreContext) as unknown as T extends WebPlatform
		? DesktopRootStore
		: MobileRootStore;
}
